import register from '../util/init'

function toggler (e, $el) {
  if ($el.classList.contains('toggle-off')) {
    $el.classList.remove('toggle-off')
    $el.classList.add('toggle-on')
  } else {
    $el.classList.add('toggle-off')
    $el.classList.remove('toggle-on')
  }

  const portfolioList = document.querySelectorAll('.portfolio-list__table')
  const portfolioArrow = document.querySelectorAll(
    '.portfolio-list__arrow--container'
  )
  const portfolioAmount = document.querySelectorAll(
    '.portfolio-list__amount'
  )
  portfolioList.forEach($p => {
    $p.classList.toggle('adviser-row-active')
  })
  portfolioArrow.forEach($t => {
    $t.classList.toggle('active')
  })
  portfolioAmount.forEach($t => {
    $t.colSpan = $el.classList.contains('toggle-off') ? 1 : 2
  })
}

export function toggleSwitchInit (container) {
  // Handle switches
  let $switchEl = Array.prototype.slice.call(
    document.querySelectorAll('.toggle-switch'),
    0
  )
  if ($switchEl.length > 0) {
    $switchEl.forEach($el => {
      $el.addEventListener('click', e => toggler(e, $el))
    })
  }
}

register('.toggle-switch', toggleSwitchInit)



// WEBPACK FOOTER //
// ./assets/j/src/qrt_switch.js